const resources = {
  addResource: null,
  fetchResource: null,
  fetchResources: null,
  updateResource: null,
  fetchResourceMedia: null,
};

export default resources;
